var app = angular.module('leonardo');

var ThDirective = function(ConfigThemeService) {
  return {
    restrict: 'EC',
    scope: {
      thColor: '@',
      thBackgroundColor: '@'
    },
    link: function (scope, element) {

      scope.$watch('thBackgroundColor', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        var color = scope.thColor ? ConfigThemeService.getColor(scope.aColor) : ConfigThemeService.config.theme_config.primaryColor;
        element.css('color', color);
        if (scope.thBackgroundColor){
          element.css('background-color', ConfigThemeService.getColor(scope.thBackgroundColor, 0.7));
        }
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('th', ['ConfigThemeService', ThDirective]);
